import CustomDrawerModal from '../common/CustomDrawerModal'
import { dispatch, useSelector } from '@/lib/store'
import { useState } from 'react'
import useCustomToast from '@/hooks/useCustomToast'
import { consumerRequest } from '@/helper/request'
import {
  POST_CAMPAIGN_LEAD_API,
  SIGNED_IN_DOCUMENT_LEAD_API,
  SIGNED_OUT_DOCUMENT_LEAD_API,
} from '@/helper/apiConstants'
import { updateCommonReducerData } from '@/lib/reducers/commonReducer'
import LOCATION_HELPER from '@/helper/locationHelper'
import RequestCallbackForm from './RequestCallbackForm'
import { FORM_TYPE_LAB_TEST, FORM_TYPE_SCHEDULE_VISIT, CONSUMER_WEB_PLATFORM } from '@/utils/constants'
import { loadState } from '@/utils/localStorage'
import { eventConstants, trackEvent } from '@/utils/events'

const RequestCallbackModal = ({
  open,
  onOpenChange,
  radiologyRequired = false,
}: any) => {
  const showToast = useCustomToast()
  const loggedInMobileNumber = loadState('ctxVal') || null

  const cityState = useSelector((state) => state.city) || {}
  const commonState = useSelector((state) => state.common) || {}
  const loginState = useSelector((state) => state.login) || {}

  const isScheduleVisit =
    commonState?.requestCallbackModalIsOpen?.type === FORM_TYPE_SCHEDULE_VISIT
      ? true
      : false

  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({
    patientName: '',
    patientPhoneNumber: loggedInMobileNumber?.toString() ?? '',
    selectedCity: cityState?.currentCityObj?.uuid,
    termsChecked: false,
  })

  const handleInputChange = (name: string, value: string | boolean) => {
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }))
  }

  const handleSubmitRequestCallback = async () => {
    if (
      !form.patientName ||
      !form.patientPhoneNumber ||
      (!isScheduleVisit && !form.selectedCity)
    ) {
      showToast('danger', 'Please fill all the details')
      return
    }
    if (!form.termsChecked) {
      showToast('danger', 'Please accept the terms and condition')
      return
    }
    const regex = /^[a-zA-Z\s]*$/

    if (!regex.test(form.patientName)) {
      showToast('danger', 'Please input valid name')
      return
    }
    setLoading(true)
    const formData = {
      city: isScheduleVisit
        ? cityState?.currentCityObj?.uuid
        : form.selectedCity,
      patientName: form.patientName,
      patientPhoneNumber: form.patientPhoneNumber,
    }
    const FINAL_API_PATH = loginState.isUserLoggedIn
      ? SIGNED_IN_DOCUMENT_LEAD_API
      : SIGNED_OUT_DOCUMENT_LEAD_API
    const APIURL = isScheduleVisit ? POST_CAMPAIGN_LEAD_API : FINAL_API_PATH
    const res: any = await consumerRequest(APIURL, 'post', formData)
    if (res?.status === true) {
      // showToast('success', 'Request has been sent successfully')
      dispatch(
        updateCommonReducerData({
          ...commonState,
          requestCallbackModalIsOpen: { modalIsOpen: false },
          commonCenterModalData: {
            commonCenterModalIsOpen: true,
            message: 'Request submitted successfully',
            description:
              'Stay tuned, our health advisor will call you shortly to create your order',
          },
        })
      )
const cityObj:any = cityState?.allCitiesList?.find(
        (item: any) => item?.uuid === form.selectedCity
      )

    const eventPayload = {
      city: cityObj?.name || null,
      app: CONSUMER_WEB_PLATFORM,
      u_n: form.patientName,
      u_mb: form.patientPhoneNumber,
    }
if (isScheduleVisit) {
  trackEvent(eventConstants.SUBMIT_NEARBY_LABS_LEAD, eventPayload)
} else {
  trackEvent(eventConstants.REQUEST_CALL_BACK, eventPayload)
}
    } else {
      showToast('danger', res?.message)
      onOpenChange(false)
    }
      setLoading(false)
  }

  const title = isScheduleVisit
    ? 'Schedule Visit'
    : `Need help in booking a ${
        commonState?.requestCallbackModalIsOpen?.type ?? FORM_TYPE_LAB_TEST
      }?`
  return (
    <CustomDrawerModal open={open} title={title} onOpenChange={onOpenChange}>
      <div className="">
        <RequestCallbackForm
          form={form}
          loading={loading}
          formType={isScheduleVisit ? FORM_TYPE_SCHEDULE_VISIT : null}
          onOpenChange={onOpenChange}
          handleSubmitRequestCallback={handleSubmitRequestCallback}
          handleInputChange={handleInputChange}
          radiologyRequired={isScheduleVisit ? false : radiologyRequired}
        />
      </div>
    </CustomDrawerModal>
  )
}

export default RequestCallbackModal
